import React from "react";

var DefaultItemRenderer = _ref => {
  var {
    checked,
    option,
    onClick,
    disabled
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "item-renderer " + (disabled && "disabled")
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    onChange: onClick,
    checked: checked,
    tabIndex: -1,
    disabled: disabled
  }), /*#__PURE__*/React.createElement("span", null, option.label));
};

export default DefaultItemRenderer;
//# sourceMappingURL=default-item.js.map